import '../style/About.css';
import { motion } from 'framer-motion';

export default function About() {
  return (
    <section className="About" id="about" aria-label="About Abstan Logistics">
      <motion.div
        className="About-inner"
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="About-copy">
          <p className="About-eyebrow">About Us</p>
          <h2 className="About-title">ABSTAN LOGISTICS LIMITED</h2>

          <div className="About-text">
            <p>
              Abstan Logistics is a trusted provider of seemless, efficient, and
              innovative logistics solutions. The company is built on
              professionalism, integrity, and a commitment to simplifying global
              supply chains.
            </p>
            <p>
              Backed by directors with over 10 years of experience in the
              logistics industry, we bring deep expertise in fright management,
              customs regulations, and supply chain optimization.
            </p>
            <p>
              Strategically positioned in a key East Africa trade hub, we
              connect businesses to international markets with customized
              freight and logistics services and ensure smooth, secure, and
              cost-effective transportation for various industries.
            </p>
          </div>
        </div>

        <div className="About-media">
          <img
            className="About-image"
            src={`${process.env.PUBLIC_URL}/image/mbili.jpeg`}
            alt="Logistics transport: containers, truck, ship and airplane"
            loading="lazy"
          />
          <div className="About-card" aria-hidden="true">
            <div className="About-cardTitle">10+ Years</div>
            <div className="About-cardSub">Logistics leadership experience</div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}

